/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { QuestionStar } from '../models/QuestionStar';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class QuestionStarsService {
    /**
     * Get all question stars
     * @returns QuestionStar successful
     * @throws ApiError
     */
    public static getAllQuestionStars(): CancelablePromise<Array<QuestionStar>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/question_stars.json',
        });
    }
    /**
     * Update question star
     * @param id Question slug
     * @param requestBody
     * @returns QuestionStar successful
     * @throws ApiError
     */
    public static updateQuestionStar(
        id: string,
        requestBody?: {
            starred: boolean;
        },
    ): CancelablePromise<QuestionStar> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/question_stars/{id}.json',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
